<template>
    <div id="ContactUs">
        <modal v-if="modalContactUs" @forceClose="modalContactUs = false"  @close="send()" type="large">
            <template v-slot:header>
                <h3>FALE CONOSCO</h3>
            </template>
            <template v-slot:body>
                <div class="form">

                    <div class="form-control" :class="{error: errorField('name').status}">
                        <label for="formContactUsName">NOME</label>

                        <input
                            type="text"
                            v-model="formContactUs.nome"
                            id="formContactUsName"
                            placeholder="@mateusdacosta"
                        />
                        <span v-if="errorField('name').status">{{errorField('name').message}}</span>
                    </div>
                    <div class="form-control" :class="{error: errorField('email').status}">
                        <label for="formContactUsEmail">E-MAIL</label>

                        <input
                            type="text"
                            v-model="formContactUs.email"
                            id="formContactUsEmail"
                            placeholder="mateusdacosta@campos.com"
                        />
                        <span v-if="errorField('email').status">{{errorField('email').message}}</span>
                    </div>
                    <div class="form-control" :class="{error: errorField('message').status}">
                        <label for="formContactUsMessage">MENSAGEM</label>

                        <textarea
                            type="text"
                            v-model="formContactUs.mensagem"
                            id="formContactUsMessage"
                            placeholder="Escreva aqui sua mensagem..."
                        />
                        <span v-if="errorField('message').status">{{errorField('message').message}}</span>
                    </div>
                </div>
            </template>
            <template v-slot:button> ENVIAR </template>
        </modal>

        <!-- Modal de envio de mensagem -->
        <modal v-if="ModalSendOk" @close="ModalSendOk = false" >
            <template v-slot:header>
                <h3>ATENÇÃO!</h3>
            </template>
            <template v-slot:body>
                {{returnMessage}}
            </template>
            <template v-slot:button> VOLTAR </template>
        </modal>
    </div>
</template>
<script>
import Modal from "@/components/Parts/Modal";
export default {
    name:"ContactUs",
    components:{Modal},
    data: () => ({
        errors: [],
        ModalSendOk: false,
        returnMessage: ""
    }),
    methods:{
        send(){

            // valida o formulário before send
            this.errors = [];

            if(this.formContactUs.email.trim() == ''){
                this.errors.push({field:"email", message: "O E-mail é obrigatório"});
            }
            if(!this.validateEmail(this.formContactUs.email)){
                this.errors.push({field:"email", message: "O E-mail precisa ser válido"});
            }
            if(this.formContactUs.nome.trim() == ''){
                this.errors.push({field:"name", message: "O nome é obrigatório"});
            }
            if(this.formContactUs.mensagem.trim() == ''){
                this.errors.push({field:"message", message: "A mensagem é obrigatória"});
            }

            if(this.errors.length > 0){
                return;
            }
            
           

            // faz o envio
            this.$store.dispatch('sendContactUs').then((res) => {
                this.returnMessage = res.message;
                    // Abre um novo notificando o envio
                    this.ModalSendOk = true;

                if(res.status){
                     //Fecha o modal
                    this.modalContactUs = false;
                    

                    // Limpa o formulário
                    this.formContactUs.email = '';
                    this.formContactUs.nome = '';
                    this.formContactUs.mensagem = '';
                }
            })

        },
        validateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
    },
    computed:{
        modalContactUs: {
            get() {
                return this.$store.getters.modalContactUs;
            },
            set(value) {
                this.$store.commit('showModalContactUs', value)
            }
        },
        formContactUs: {
            get() {
                return this.$store.getters.formContactUs;
            },
            set(value) {
                this.$store.commit('setFormContactUs', value)
            }
        },
        errorField: function() {
            return (field) => {
                var field = this.errors.find(error => error.field == field)

                if(field){
                    return {
                        status: true,
                        message: field.message
                    }
                }else{
                    return {
                        status: false
                    }
                }
            };
            }
    },
    updated(){
        // Limpa o formulário
        this.formContactUs.email = '';
        this.formContactUs.nome = '';
        this.formContactUs.mensagem = '';
        this.errors = [];
    }
}
</script>